import React, {useState, useEffect} from 'react';
import useUserContext from '../common/UserContext';
import { useParams, Link, useHistory } from 'react-router-dom';

import { apiGet, getAdminApiUrl, apiMessages, getAccountsApiUrl, getBenefitsApiUrl, apiPost } from '../common/AppApi';
import Processing from '../common/Processing';
import MessageTag from '../common/MessageTag';

import { selectOptions } from '../common/Forms';
import Strings from '../common/Strings';
import Pagination, { resetPaging } from '../common/Pagination';

import AlertDialog, {showAlertDialog} from '../common/AlertDialog';
import DisplayPans from './DisplayPans';
import { prepareDownloadUrl } from '../common/CommonUtils';

export default function Program(props) {
	let alertCount = 400;

	let {user} = useUserContext();
	let blankRecipient = {
		accountUuid: '',
		recipientIdentifier: '',
		accountTypeId:''
	};
	
	let [recipient, setRecipient] = useState(blankRecipient);
	let [pans, setPans] = useState([]);
	let [pagingData, setPagingData] = useState(resetPaging());
	let [showSpinner, setSpinner] = useState(false);
    let [message, setMessage] = useState();
	let [programs, setPrograms] = useState([]);

	// max available to print
	let getMaxPans = () => {
		if (recipient && recipient.maxPrintedPans)
			return recipient.maxPrintedPans;
		return 0;
	};

	let getPrograms = () => {
		let url = getAccountsApiUrl() + '/account/programs';
		if (props.admin) {
			url = getAdminApiUrl() + '/programs?programStatusId=0';
		}

		setSpinner(true);
		apiGet(url).then((resp)=> {
			let programs = [];
			resp.forEach( (p) => {
				programs.push({id:p.programUuid, text:p.programName});
			});
			setPrograms(programs);
		}).catch( (err) => {
			console.error(err);
			let messageObject = {text:Strings.error.general,type:'danger'};
			if(err.privilegeError){
				messageObject.text = <>{err.message}</>;
			}
			setMessage(messageObject);
		}).finally(() => setSpinner(false));
	};

	useEffect(() => {
		getPrograms();
	}, []);

	useEffect(() => {
		if (programs && programs.length)
			getProgram(programs[0].id);
	}, [programs]);

	let getProgramRecipient = (progId) => {
		setSpinner(true);
		let url = getAccountsApiUrl() + '/account/pangen/' + progId;

		apiGet(url).then((resp) => {
			//console.debug(resp);
			let cloned = {...resp};
			setRecipient(cloned);
			getRecipientPans(progId, resp.accountUuid);
			
		}).catch( (err) => {
			console.error(err);
			let messageObject = {text:Strings.error.general,type:'danger'};
			if(err.privilegeError){
				messageObject.text = <>{err.message}</>;
			} else {
				messageObject.text = 'Error settting up pan generation.';
			}
			setMessage(messageObject);
		}).finally(() => setSpinner(false));
	};

	let getRecipientPans = (progId, acctUuid) => {
		setSpinner(true);
		let url = getAccountsApiUrl() + '/pans?programId=' + progId + '&accountUuid=' + acctUuid;

		apiGet(url).then((resp) => {
			//console.debug(resp);
			setPans(resp);
			setPagingData(resetPaging());

			if (resp.length < 1)
				setMessage({text:'No printed pans available.',type:'warning'});

		}).catch( (err) => {
			console.error(err);
			let messageObject = {text:Strings.error.general,type:'danger'};
			if(err.privilegeError){
				messageObject.text = <>{err.message}</>;
			} else if(err.status == 400 || err.status == 404){
				messageObject.text = apiMessages(err);
			}
			setMessage(messageObject);
		}).finally(() => setSpinner(false));
	};

	let [program, setProgram] = useState({programName:'', programId:'', programUuid:''});
	let getProgram = (id) => {
		setSpinner(true);
		let url = getAdminApiUrl() + '/programs/' + id;
		apiGet(url).then((resp) => {
			//console.debug(resp);
			setProgram(resp);
			setMessage(null);

			getProgramRecipient(resp.programId);
		}).catch( (err) => {
			console.error(err);
			let messageObject = {text:Strings.error.general,type:'danger'};
			if(err.privilegeError){
				messageObject.text = <>{err.message}</>;
			} else if(err.status == 400){
				messageObject.text = apiMessages(err);
			}
			setMessage(messageObject);
		}).finally( () => setSpinner(false) );
	};
	
	let handleFieldChange2 = (event) => {
		const {id, value} = event.target;
		getProgram(value);
	}

	let ProgramDropdown = () => {
		if (programs && programs.length > 1) {
			return (<>
				<form onSubmit={ e => console.debug('no action')}>
				<div className="form-group col-12 col-sm-10 col-md-6 col-lg-4">
					<label htmlFor="programUuid"><strong>Program</strong></label>
					<select id="programUuid" className="form-control custom-select" value={program.programUuid} onChange={handleFieldChange2} >
						{ selectOptions( programs ) }
					</select>
				</div>
				</form>
			</>);
		} else {
			return null;
		}
	}

	let alertSettingsDefault = {type:'success', body:'', button:'Dismiss'};
	let [alertSettings, setAlertSettings] = useState(alertSettingsDefault);

	let PanGenerationForm = () => {
		let panForm = {
			accountUuid:'',
			panCount:''
		};
		let [pan, setPan] = useState(panForm);
	
		let handleFieldChange = (event) => {
			const {id, value} = event.target;
			let cloned = {...pan, [id]:value};
			setPan(cloned);
		}

		let checkStyle = {padding:".1em 1.5em .1em .5em", cursor:'pointer'};
		let [confirmed, setConfirmed] = useState(false);
		let handleConfirmCheckbox = (event) => {
			const { value, checked } = event.target;
			setConfirmed(checked);
		};

		let genPans = (e) => {
			e.preventDefault();
			setSpinner(true);

			if (props.admin && (pan.panCount > getMaxPans())) {
				let message = "You are about to submit a request for greater than the max printable pans setting configured.\n";
				message += "Overriding this value is not something that should be done on a regular basis.";
				message += "This feature should only be used for special preplanned circumstances.\n";
				message += "Are you sure you want to override the max printable pans setting for this program?";
				if (window.confirm(message)) {
					console.debug("Ignoring max printable pans setting.");
				} else {
					setSpinner(false);
					return false;
				}
			} else {
				if (pan.panCount > getMaxPans()) {
					setSpinner(false);
					setAlertSettings({type:'warning', body:'Pan generation count cannot be more than ' + getMaxPans() + '.'});
					showAlertDialog();
					return;
				}
			}
	
			let body = {
				programId:program.programId,
				accountUuid:recipient.accountUuid,
				count:pan.panCount
			};
	
			let url = getAccountsApiUrl() + '/pans/gen/printed';
			apiPost(url, body).then((resp) => {
				//console.log(resp);
				setMessage({text:'New Pans have been generated.'});
				//getRecipientPans(program.programId, recipient.accountUuid);
				getProgramRecipient(program.programId);
				setConfirmed(false);

				getProgram(program.programUuid);

				let pdfUrl = prepareDownloadUrl(getBenefitsApiUrl() + '/pans/qrcode/pdfs/' + resp.panGenId);

				if (resp.panId && resp.panId > alertCount) {
					setAlertSettings({type:'success',
						 body:<>The pan generation was successful.<br/>The pdf file may take a minute to download.</>,
						 button:'Dismiss'});
					showAlertDialog();
				}

				if (user.testMode) {
					console.debug('skipping download for selenium tests');
				} else {
					setTimeout( () => {
						window.location = pdfUrl;
					}, 500);
				}

			}).catch( (err) => {
				console.error(err);
				let messageObject = {text:Strings.error.general,type:'danger'};
				if(err.privilegeError){
					messageObject.text = <>{err.message}</>;
				} else if(err.status == 400 || err.status == 404){
					messageObject.text = apiMessages(err);
				} else if(err.status == 422){
					messageObject = null;
					setTimeout( () => {
						setAlertSettings({type:'warning', body:Strings.warning.countAvailableConflict});
						showAlertDialog();
						getProgramRecipient(program.programId);
					}, 400);
				} else if(err.status == 409) {
					messageObject = {text:Strings.warning.panGenInProcess,type:'warning'};
					setTimeout( () => {
						setAlertSettings({type:'warning', body:<>{Strings.warning.panGenInProcess}<br/>{Strings.warning.pleaseWaitAFew}</>});
						showAlertDialog();
						getProgramRecipient(program.programId);
					}, 400);
				}
				setMessage(messageObject);
			}).finally(() => setSpinner(false));
		};
		
		if (recipient.accountTypeId == '1') {
			let disabledBtn = props.admin ? false : getMaxPans() < 1;

			return (<>
			<form onSubmit={genPans}>
				<div className="row">
					<div className="form-group required col-12 col-sm-2">
						<label className="asterisk-label" htmlFor="panCount">Count</label>
						<input type="text" id="panCount" className="form-control" value={pan.panCount} onChange={handleFieldChange} required maxLength="4" pattern="\d+" disabled={disabledBtn}/>
						<small className="form-text text-muted">{getMaxPans()} maximum per program</small>
					</div>
					<div className="form-group required col-12 col-sm-3">
						<br/>
						<button className='btn btn-primary' id="btnGen" disabled={disabledBtn}>Generate and Print PANs</button>
					</div>
				</div>
				<div className='row'>
					<div className="form-group required col-12 col-md-3">
						<label style={checkStyle}>
							<input type="checkbox" title="Are you sure?" value={1} checked={confirmed} onChange={handleConfirmCheckbox} required id="areYouSure"/>
							<span style={{marginLeft:10}}>Confirm generate and print.</span>
						</label>
					</div>
				</div>
			</form>
			</>);
		}

		return null;
	};

	return (
		<>
		<Processing show={showSpinner}/>
		<h3>Pan Generation</h3>
		<MessageTag message={message}/>
		<ProgramDropdown />
		<table className="table table-bordered">
			<tbody>
				<tr>
					<th>Program Name</th>
					<th>Shortname</th>
				</tr>
				<tr>
					<td>{program.programName}</td>
					<td>{program.shortName}</td>
				</tr>
			</tbody>
		</table>

		<PanGenerationForm />

		<DisplayPans pans={pans} pagingData={pagingData} setPagingData={setPagingData}
		 statusSuccess={() => getProgramRecipient(program.programId)} setMessage={setMessage}/>

		<AlertDialog settings={alertSettings} />
		</>
	);
}
